import { render, staticRenderFns } from "./DropdownOptionSlot.vue?vue&type=template&id=4e2617ca&shadow"
import script from "./DropdownOptionSlot.vue?vue&type=script&lang=js&shadow"
export * from "./DropdownOptionSlot.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports